export const faqGeneral = [
  {
    title: "¿Qué es TBM Rewards?",
    htmlContent:
      "TBM Rewards es nuestro programa de recompensas diseñado para celebrar tu constancia y motivarte en tu camino fitness con The Body Method, tanto si entrenas en nuestros estudios en Monterrey y Tijuana como en línea.",
  },
  {
    title: "¿Quién puede participar en TBM Rewards?",
    htmlContent:
      "Todas las alumnas activas de The Body Method, tanto en modalidad presencial como en línea, son elegibles para participar en TBM Rewards.",
  },
  {
    title: "¿Tengo que inscribirme en TBM Rewards?",
    htmlContent:
      "Generalmente, la participación es automática para todas las alumnas activas. Sin embargo, estate atenta a cualquier comunicación específica sobre el proceso de activación o aceptación de los términos.",
  },
  {
    title: "¿Tiene algún costo participar en TBM Rewards?",
    htmlContent:
      "No, la participación en TBM Rewards es gratuita para todas nuestras alumnas activas.",
  },
  {
    title: "¿Dónde puedo encontrar más información sobre TBM Rewards?",
    htmlContent:
      'Toda la información detallada sobre el programa, incluyendo cómo funciona, los niveles, las recompensas y las reglas, está disponible en esta página <a href="https://thebodymethod.mx/rewards/#" target="_blank">thebodymethod.mx/rewards</a>. También te mantendremos informada a través de nuestros canales de comunicación habituales.',
  },
];

export const faqPresencial = [
  {
    title: "¿Cómo gano progreso si entreno en los estudios?",
    htmlContent:
      "Al adquirir un paquete de 12, 16, 20 clases o el paquete ilimitado (mínimo 20 clases), y tomar todas dentro del periodo de vigencia, tu asistencia se registra y cuenta para el progreso.",
  },
  {
    title: "¿Cómo avanzo de nivel en la modalidad presencial?",
    htmlContent:
      "Debes completar tu paquete de forma constante durante dos periodos consecutivos. Puedes definir los periodos por tiempo de vigencia o por finalización anticipada de créditos.",
  },
  {
    title:
      "¿Qué pasa si no completo todas mis clases dentro del periodo de vigencia?",
    htmlContent:
      "Si no completas el número de clases de tu paquete dentro del periodo de vigencia, no avanzarás de nivel (primer strike).",
  },
  {
    title: "¿Qué son los 'strikes' en la modalidad presencial?",
    htmlContent:
      "El primer strike impide avanzar. El segundo te hace retroceder un nivel. El tercero reinicia tu progreso al nivel inicial.",
  },
];

export const faqOnline = [
  {
    title: "¿Cómo gano progreso si entreno en línea?",
    htmlContent:
      "Utiliza el Workout Planner para planificar mínimo 3 entrenamientos por semana y márcalos como completados. Esto cuenta como progreso.",
  },
  {
    title: "¿Cómo avanzo de nivel en la modalidad en línea?",
    htmlContent:
      "Cumpliendo de forma constante tu Workout Planner durante dos meses consecutivos.",
  },
  {
    title: "¿Cómo mide la plataforma mi progreso en línea?",
    htmlContent:
      "La plataforma registra automáticamente las clases que marcas como completadas en tu Workout Planner.",
  },
  {
    title: "¿Qué pasa si no cumplo con mi Workout Planner en un mes?",
    htmlContent: "No avanzarás de nivel (primer strike).",
  },
  {
    title: "¿Qué son los 'strikes' en la modalidad en línea?",
    htmlContent:
      "El primer strike impide avanzar. El segundo te hace retroceder un nivel. El tercero reinicia tu progreso al nivel inicial.",
  },
];

export const faqLevels = [
  {
    title: "¿Cuántos niveles hay en TBM Rewards?",
    htmlContent: "Actualmente, hay seis niveles en TBM Rewards.",
  },
  {
    title: "¿Cómo sé en qué nivel estoy?",
    htmlContent:
      "Podrás ver tu nivel actual dentro de tu sesión en nuestra página.",
  },
  {
    title: "¿Qué tipo de recompensas puedo obtener?",
    htmlContent:
      "Las recompensas varían según tu nivel y las colaboraciones con marcas. Pueden incluir descuentos, acceso a eventos, regalos y más.",
  },
  {
    title: "¿Cuándo recibiré mis recompensas?",
    htmlContent:
      "Depende de cada recompensa. Te informaremos cómo y cuándo podrás disfrutar de tus beneficios.",
  },
  {
    title: "¿Qué son las recompensas de los meses nones?",
    htmlContent:
      "Además de las recompensas por nivel, ofrecemos beneficios en los meses 1, 3, 5, 7, 9 y 11 como reconocimiento a tu constancia.",
  },
  {
    title: "¿Las recompensas son garantizadas?",
    htmlContent:
      "Hacemos nuestro mejor esfuerzo por ofrecerlas, pero están sujetas a disponibilidad y pueden cambiar.",
  },
];

export const faqBrands = [
  {
    title: "¿Qué marcas participan en TBM Rewards?",
    htmlContent:
      "Colaboramos con marcas del mundo del bienestar: activewear, proteínas, skincare y más. Se anunciarán por nuestros canales.",
  },
  {
    title: "¿Cómo obtengo las recompensas de las marcas colaboradoras?",
    htmlContent:
      "Recibirás detalles (códigos de descuento, enlaces, etc.) cuando alcances el nivel correspondiente o durante los meses especiales.",
  },
];

export const faqRules = [
  {
    title:
      "¿Qué pasa si hago una clase suelta y no tengo un paquete activo? (Modalidad Presencial)",
    htmlContent:
      "Debes tener un paquete activo para que tus clases cuenten en el avance de niveles.",
  },
  {
    title: "¿Puedo transferir mis recompensas a otra persona?",
    htmlContent: "No, las recompensas no son transferibles.",
  },
  {
    title: "¿Qué sucede si cancelo mi membresía o dejó de ser alumna de TBM?",
    htmlContent:
      "Tu participación en TBM Rewards finalizará y perderás cualquier nivel o recompensa acumulada.",
  },
  {
    title: "¿Dónde puedo leer los Términos de Uso completos de TBM Rewards?",
    htmlContent: "Puedes consultarlos en nuestra página oficial.",
  },
];

export const BrandIcon = ({ src }) => {
  return <img alt="menu icon" width={50} height={"auto"} src={src} />;
};

const TbmIcon = ({ small, onClick }) => {
  return (
    <img
      alt="tbm logo"
      onClick={onClick}
      width={small ? 30 : 50}
      height={small ? 30 : 50}
      src="/img/tbm-icon.png"
    />
  );
};

const MenuIcon = ({ small, onClick }) => {
  return (
    <img
      alt="menu icon"
      onClick={onClick}
      width={small ? 30 : 50}
      height={small ? 30 : 50}
      src="/img/menu.png"
    />
  );
};